import { makeStyles } from '@griffel/react';

import type { GriffelClassNames } from '../../../../util/classNames';
import { tokens } from '../../../../util/theme/fluent9';

export const useClassNames: () => GriffelClassNames<'leftNavContainer'> = makeStyles({
  leftNavContainer: {
    borderRight: `1px solid ${tokens.colorNeutralStroke3}`,
    backgroundColor: tokens.colorNeutralBackground2,
    zIndex: 2,
  },
});
